import { Directive, TemplateRef, inject } from "@angular/core";

@Directive({ 
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: "[accordionContent]" })
export class AccordionContentDirective {
    templateRef = inject<TemplateRef<any>>(TemplateRef);
}
